import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=8acffd74&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&lang=css&"
import style1 from "./setting.vue?vue&type=style&index=1&id=8acffd74&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acffd74",
  null
  
)

export default component.exports